import { ArrowDownUp } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";

/**
 * Issue #460 — the header, sort control and scroll box shared by the Coach
 * Portal's four unbounded lists (Goals, Feedback, Match reflections,
 * Reflections).
 *
 * ONE COMPONENT, not four copies of a `max-h-… overflow-y-auto` div: three
 * of the four already carried the scroll box and the fourth (Goals) did
 * not, which is exactly the drift a shared container prevents. The sort
 * ORDERS themselves are `lib/coachListSort.js`; this only renders the
 * picker for whatever table it is handed.
 *
 * `min-w-0` on the header row and `flex-wrap` on it are the #251/#141 class
 * of fix this page keeps needing: a nowrap title beside a fixed-width
 * Select inside a `lg:grid-cols-4` track pushes the whole grid wide at
 * phone-390 unless both are told they may shrink and wrap.
 */
export default function CoachListSection({
  title,
  description,
  sorts,
  sortValue,
  onSortChange,
  sortTestId,
  controls,
  listTestId,
  children,
}) {
  return (
    <>
      <div className="flex items-center justify-between gap-2 flex-wrap min-w-0">
        <h3 className="font-display font-bold text-lg text-slate-900 min-w-0">{title}</h3>
        <div className="flex items-center gap-2 flex-wrap">
          {controls}
          {/* The icon sits OUTSIDE the trigger: shadcn's `SelectTrigger` is
              `justify-between` and clamps its `> span`, so an extra child
              in there spreads the row and fights the value's own clamp. */}
          <div className="flex items-center gap-1.5">
            <ArrowDownUp size={13} className="text-slate-400 shrink-0" aria-hidden="true" />
            <Select value={sortValue} onValueChange={onSortChange}>
              <SelectTrigger className="w-36 h-8 text-xs" aria-label={`Sort ${title}`} data-testid={sortTestId}>
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                {sorts.map((s) => (
                  <SelectItem key={s.value} value={s.value}>{s.label}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        </div>
      </div>

      {description}

      {/* `overscroll-contain` so reaching the end of a long list does not
          hand the scroll to the page underneath mid-review, which on a phone
          reads as the list jumping. `pr-1` keeps the scrollbar off the
          cards' right edge. */}
      <div
        className="mt-3 space-y-3 max-h-[420px] overflow-y-auto overscroll-contain pr-1"
        data-testid={listTestId}
      >
        {children}
      </div>
    </>
  );
}
